import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve } from '@angular/router';
import { ApiCallService } from './api-call.service';
import { Agency } from '../models/index';

@Injectable({ providedIn: 'root' })
export class AgencyShowcaseService implements Resolve<Agency> {
  constructor(private apiCallService: ApiCallService) {}

  public getAgencyShowcase(agencyUuid: string): Promise<Agency> {
    this.apiCallService.agencyUuid = agencyUuid;
    const promise = this.apiCallService.get('/showcase');
    return promise;
  }

  resolve(route: ActivatedRouteSnapshot): Promise<Agency> {
    const promise = this.getAgencyShowcase(route.params['agency_uuid']).catch(
      (error) => {
        throw error;
      }
    );

    return promise;
  }
}
